// extracted by mini-css-extract-plugin
export var boldText = "_36-4";
export var checkboxContainer = "_36-6";
export var closeIcon = "_36-i";
export var container = "_36-0";
export var drawer = "_36-8";
export var drawerContent = "_36-9";
export var extraSmallText = "_36-5";
export var fulfillmentGroupTable = "_36-e";
export var largeText = "_36-3";
export var loadingSpinnerContainer = "_36-j";
export var mediumText = "_36-2";
export var narrow = "_36-f";
export var notificationLink = "_36-l";
export var packageCheckIconContainer = "_36-7";
export var slideoutHeaderActions = "_36-g";
export var slideoutHeaderActionsShifted = "_36-h";
export var slideoutHeaderContainer = "_36-a";
export var slideoutModal = "_36-c";
export var stickyHeaderWrapper = "_36-b";
export var table = "_36-k";
export var tableContainer = "_36-d";
export var tertiaryText = "_36-1";